import { Contact } from './Contact';
import { DiscardableModel } from './DiscardableModel';
import { ErroredModel } from './ErroredModel';
import { PaginationMeta } from './pagination';
import { TaggableModel } from './Tag';

export type EmailTemplate = ErroredModel &
  TaggableModel &
  DiscardableModel & {
    uuid: string;
    name: string;
    subject: string;
    reply_to: string;
    description: string;
    content: string;
  };

export type EmailTemplateResponse = {
  data: EmailTemplate[];
  meta: PaginationMeta;
};

export enum EmailTemplateStartCondition {
  MANUAL = 'manual',
  DATE_OFFSET = 'date_offset',
  TASK_DEPENDENCY = 'task_dependency',
  EVENT_DEPENDENCY = 'event_dependency',
}

export type EmailTemplateLink = {
  uuid: string;
  email_template_uuid: string;
  event_template_email_template_uuid?: string;
  email_template_name?: string;
  offset: number | null;
  roles_uuids: string[];
  roles_values: string[];
  email_template_subject?: string;
  email_template_custom_fields?: string[];
  depends_on_uuid?: string | null;
  start_condition: EmailTemplateStartCondition;
  new_record?: boolean;
};

export enum EmailTemplateRecipientsType {
  CONTACT = 'contact',
  EMPLOYEE = 'employee',
}

export type EmailTemplateRecipientsResponse = {
  data: Contact[];
  type: EmailTemplateRecipientsType;
};
